// Suit Designer catalogues + CSS swatch synthesis. Shared between
// SuitDesignerModal (controls) and SuitDesignerPreview (compositor).
export const LINER_CATALOG = [
  { id: 'burgundy-silk',   name: 'Burgundy Silk',    kind: 'solid',   color: '#5B0E1F', family: 'red' },
  { id: 'navy-silk',       name: 'Navy Silk',        kind: 'solid',   color: '#0F1E3D', family: 'blue' },
  { id: 'black-silk',      name: 'Black Silk',       kind: 'solid',   color: '#0A0A0C', family: 'black' },
  { id: 'forest-silk',     name: 'Forest Silk',      kind: 'solid',   color: '#1F3D2A', family: 'green' },
  { id: 'ivory-silk',      name: 'Ivory Silk',       kind: 'solid',   color: '#F0E9DA', family: 'neutral' },
  { id: 'gold-silk',       name: 'Gold Silk',        kind: 'solid',   color: '#B8934A', family: 'gold' },
  { id: 'royal-silk',      name: 'Royal Blue Silk',  kind: 'solid',   color: '#1A3D8F', family: 'blue' },
  { id: 'charcoal-silk',   name: 'Charcoal Silk',    kind: 'solid',   color: '#232529', family: 'grey' },
  { id: 'paisley-burgundy',name: 'Paisley · Burgundy',kind: 'paisley', color: '#5B0E1F', family: 'red' },
  { id: 'paisley-gold',    name: 'Paisley · Gold',   kind: 'paisley', color: '#B8934A', family: 'gold' },
  { id: 'floral-navy',     name: 'Floral · Navy',    kind: 'floral',  color: '#0F1E3D', family: 'blue' },
  { id: 'stripe-navy',     name: 'Silk Stripe · Navy',kind: 'stripe', color: '#0F1E3D', family: 'blue' },
  { id: 'houndstooth',     name: 'Micro Houndstooth',kind: 'hound',   color: '#333333', family: 'grey' },
  { id: 'geometric',       name: 'Geometric Diamond',kind: 'diamond', color: '#3D2A1F', family: 'brown' },
  { id: 'brocade',         name: 'Brocade Damask',   kind: 'damask',  color: '#4A1F3D', family: 'purple' },
];

export const BUTTON_STYLES = [
  { id: '1b_low',   label: '1 Button · Low Stance',   count: 1, stance: 'low',      dbl: false },
  { id: '2b',       label: '2 Button',                count: 2, stance: 'standard', dbl: false },
  { id: '3b',       label: '3 Button',                count: 3, stance: 'high',     dbl: false },
  // Iter 133.2 — DB base photos generated + wired to GARMENT_BY_BUTTON;
  // DB styles now exposed. Notch lapels don't pair with DB by menswear
  // convention — the modal enforces peak/shawl only when DB is picked.
  { id: '2db',      label: '2 Button · Double Breasted', count: 2, stance: 'standard', dbl: true },
  { id: '4db',      label: '4 Button · Double Breasted', count: 4, stance: 'standard', dbl: true },
  { id: '6db',      label: '6 Button · Double Breasted', count: 6, stance: 'standard', dbl: true },
];

export const BUTTON_COLOURS = [
  { id: 'horn-dark',  label: 'Dark Horn',      hex: '#1E1712' },
  { id: 'horn-med',   label: 'Medium Horn',    hex: '#5A3E22' },
  { id: 'horn-light', label: 'Light Horn',     hex: '#A67C4D' },
  { id: 'mop',        label: 'Mother of Pearl',hex: '#E8E4DA' },
  { id: 'gold',       label: 'Gold',           hex: '#C2A878' },
  { id: 'silver',     label: 'Silver',         hex: '#B8B8BC' },
  { id: 'black',      label: 'Black',          hex: '#0A0A0C' },
  { id: 'match',      label: 'Match Fabric',   hex: null },   // resolved at render time
];

export const LAPEL_TYPES = [
  { id: 'notch', label: 'Notch',  desc: 'The everyday standard — single- and double-breasted.' },
  { id: 'peak',  label: 'Peak',   desc: 'Formal, powerful — signature of double-breasted and tuxedos.' },
  { id: 'shawl', label: 'Shawl',  desc: 'Rounded, continuous — tuxedo and smoking-jacket territory.' },
  { id: 'none',  label: 'No Lapel', desc: 'Collarless mandarin neckline — modern, minimal.' },
];

// Menswear pairing rules: 2-button DB is peak/shawl only; other DBs
// never go collarless; the mandarin (no-lapel) look is SB territory.
export function allowedLapelsFor(buttonStyleId) {
  if (buttonStyleId === '2db') return ['peak', 'shawl'];
  if (buttonStyleId === '4db' || buttonStyleId === '6db') return ['notch', 'peak', 'shawl'];
  return ['notch', 'peak', 'shawl', 'none'];
}

export const LAPEL_WIDTH_MIN = 2.25;
export const LAPEL_WIDTH_MAX = 5.0;
export const LAPEL_WIDTH_DEFAULT = 3.5;

export const VENT_STYLES = [
  { id: 'none',   label: 'No Vent',      desc: 'Continental / Italian tradition. Clean silhouette.' },
  { id: 'center', label: 'Single Center',desc: 'American classic. Casual, comfortable.' },
  { id: 'double', label: 'Double Side',  desc: 'British/Savile Row. Formal, structured.' },
];

export const POCKET_STYLES = [
  { id: 'patched', label: 'Patched',   desc: 'Sporty, casual — signals soft construction.' },
  { id: 'jetted',  label: 'Jetted',    desc: 'Formal, dressy — hidden slit only.' },
  { id: 'flapped', label: 'Flapped',   desc: 'Business standard — flaps tuck in for evening.' },
];

export const BREAST_POCKET_STYLES = [
  { id: 'none',  label: 'None' },
  { id: 'welt',  label: 'Welt (Standard)' },
  { id: 'patch', label: 'Patch' },
];

export const PANEL_MODES = [
  { id: 'full',      label: '1 Full Panel',    desc: 'One image stretched across the whole interior.' },
  { id: 'triptych',  label: '3 Panels',        desc: 'Split across three vertical panels — heraldic feel.' },
  { id: 'repeat',    label: 'Repeating Panel', desc: 'Tiled as a pattern across the interior.' },
];

// ─── SWATCH RENDER HELPERS ───────────────────────────────────────
// Returns a full CSS style object for the compositor's liner layer.
// (The older `linerCssBackground` produced a single-string return value
// which packed color + url together as `${color} url(${svg})` — that
// syntax is the CSS `background` shorthand and is INVALID when spread
// into `background-image`, so patterned liners silently failed to
// render. We now emit backgroundColor + backgroundImage as separate
// properties so every catalogue swatch — solid, stripe, hound, and all
// pattern kinds — works reliably.)
export function linerCssStyle(liner) {
  if (!liner) return { backgroundColor: '#0A0A0C' };
  const c = liner.color;
  switch (liner.kind) {
    case 'solid':
      return {
        backgroundImage: `radial-gradient(ellipse at 30% 25%, ${_lighten(c, 22)} 0%, ${c} 45%, ${_darken(c, 10)} 100%)`,
        backgroundSize: 'cover',
      };
    case 'stripe':
      return {
        backgroundImage: `repeating-linear-gradient(35deg, ${c} 0 6px, ${_lighten(c, 12)} 6px 8px, ${c} 8px 14px)`,
        backgroundSize: 'auto',
      };
    case 'hound':
      return {
        backgroundColor: c,
        backgroundImage: `url("${_houndSvg(c)}")`,
        backgroundSize: '18px 18px',
        backgroundRepeat: 'repeat',
      };
    case 'paisley':
    case 'floral':
    case 'damask':
    case 'diamond':
      return {
        backgroundColor: c,
        backgroundImage: `url("${_patternSvg(liner.kind, c)}")`,
        backgroundSize: '80px 80px',
        backgroundRepeat: 'repeat',
      };
    default:
      return { backgroundColor: c };
  }
}

// Legacy single-string helper — retained for CSS `background:` shorthand
// use cases (e.g. small swatch chips in the LINER tab picker). Do NOT
// use in `background-image`; use `linerCssStyle` instead.
export function linerCssBackground(liner) {
  if (!liner) return '#0A0A0C';
  const c = liner.color;
  switch (liner.kind) {
    case 'solid':
      return `radial-gradient(ellipse at 30% 25%, ${_lighten(c, 22)} 0%, ${c} 45%, ${_darken(c, 10)} 100%)`;
    case 'stripe':
      return `repeating-linear-gradient(35deg, ${c} 0 6px, ${_lighten(c, 12)} 6px 8px, ${c} 8px 14px)`;
    case 'hound':
      return `${c} url("${_houndSvg(c)}")`;
    case 'paisley':
    case 'floral':
    case 'damask':
    case 'diamond':
      return `${c} url("${_patternSvg(liner.kind, c)}")`;
    default:
      return c;
  }
}

// Canvas-compositor helpers (SuitDesignerPreview draws liners on a
// <canvas> at true display resolution instead of CSS backgrounds).
export function shadeHex(hex, amt) { return _shift(hex, amt); }
export function linerPatternSvg(kind, c) {
  return kind === 'hound' ? _houndSvg(c) : _patternSvg(kind, c);
}

function _lighten(hex, amt) { return _shift(hex,  amt); }
function _darken(hex, amt) { return _shift(hex, -amt); }
function _shift(hex, amt) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = Math.max(0, Math.min(255, ((n >> 16) & 0xff) + amt));
  const g = Math.max(0, Math.min(255, ((n >> 8) & 0xff) + amt));
  const b = Math.max(0, Math.min(255, (n & 0xff) + amt));
  return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
}
function _houndSvg(c) {
  const l = _lighten(c, 20);
  const s = `<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><rect width='12' height='12' fill='${c}'/><path d='M0,0 L6,0 L6,6 L0,6 Z' fill='${l}' opacity='.55'/><path d='M6,6 L12,6 L12,12 L6,12 Z' fill='${l}' opacity='.55'/></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(s)}`;
}
function _patternSvg(kind, c) {
  const l = _lighten(c, 32);
  let shape = '';
  if (kind === 'paisley') {
    shape = `<path d='M20,10 Q30,20 25,32 Q20,44 30,50 M15,15 Q22,25 18,35' stroke='${l}' fill='none' stroke-width='1.2' opacity='.7'/>`;
  } else if (kind === 'floral') {
    shape = `<g fill='${l}' opacity='.55'><circle cx='15' cy='15' r='2.5'/><circle cx='35' cy='30' r='2'/><circle cx='45' cy='12' r='1.6'/><circle cx='25' cy='45' r='2.2'/></g>`;
  } else if (kind === 'damask') {
    shape = `<path d='M25,10 L30,25 L25,40 L20,25 Z M15,25 L25,20 L25,30 Z M35,25 L25,20 L25,30 Z' fill='${l}' opacity='.55'/>`;
  } else if (kind === 'diamond') {
    shape = `<path d='M25,5 L45,25 L25,45 L5,25 Z' fill='none' stroke='${l}' stroke-width='1' opacity='.6'/><path d='M25,15 L35,25 L25,35 L15,25 Z' fill='none' stroke='${l}' stroke-width='.8' opacity='.4'/>`;
  }
  const s = `<svg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 50 50'><rect width='50' height='50' fill='${c}'/>${shape}</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(s)}`;
}
